import { render, staticRenderFns } from "./EntityThumbnail.vue?vue&type=template&id=a08a9d02&scoped=true&"
import script from "./EntityThumbnail.vue?vue&type=script&lang=js&"
export * from "./EntityThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./EntityThumbnail.vue?vue&type=style&index=0&id=a08a9d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08a9d02",
  null
  
)

export default component.exports